import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';

import { Box } from '@mui/material';
import { SCUIBreadCrumb } from '../../atomic/molecules';
import { SCUIContent } from '../../atomic/organisms';
import { SCUILoadingLinear } from '../../atomic/atoms';
import { SummaryDetail, SummaryList } from './components';

import { SummaryCommand } from '../../services/command';
import { PaymentConsolidationAccountingStatus } from './enum/SummaryEnums';

export const Summary = () => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [summaryList, setSummaryList] = useState<any[]>([]);
    const [selectedSummary, setSelectedSummary] = useState<any>({});
    const [startDate, setStartDate] = useState<string | Date>('');
    const [endDate, setEndDate] = useState<string | Date>('');
    const [isSearched, setIsSearched] = useState<boolean>(false);
    const [status, setStatus] = useState<any>(PaymentConsolidationAccountingStatus.All);

    const { t } = useTranslation();

    const handleSearch = () => {
        setIsLoading(true);
        setIsSearched(true);
        SummaryCommand.GetSummaryList({
            periodBeginDate: startDate,
            periodEndDate: endDate,
            AccountingStatusId: status === PaymentConsolidationAccountingStatus.All ? null : status,
        })
            .then((res: any) => {
                if (res.paymentConsolidations) {
                    setSummaryList(res.paymentConsolidations || []);
                }
                setIsLoading(false);
            })
            .catch(() => {
                Swal.fire(t('general.anErrorOccured'), '', 'error');
                setIsLoading(false);
            });
    };

    const handlePrint = (id: any) => {
        setIsLoading(true);
        SummaryCommand.PrintSummary({
            paymentConsolidationId: id,
            accountingStatus: PaymentConsolidationAccountingStatus.AccountingComplate,
        })
            .then((res: any) => {
                if (res) {
                    Swal.fire({
                        icon: 'success',
                        title: t('general.success'),
                        showConfirmButton: false,
                        timer: 1500,
                    });
                    handleSearch();
                }
            })
            .catch(() => {
                Swal.fire(t('general.anErrorOccured', '', 'error'));
                setIsLoading(false);
            });
    };

    const handleAxapta = (id: any) => {
        setIsLoading(true);
        SummaryCommand.AxaptaTransferSummary({
            paymentConsolidationId: id,
        })
            .then((res: any) => {
                if (res) {
                    Swal.fire({
                        icon: 'success',
                        title: t('general.success'),
                        showConfirmButton: false,
                        timer: 1500,
                    });
                    handleSearch();
                }
            })
            .catch(() => {
                Swal.fire(t('general.anErrorOccured', '', 'error'));
                setIsLoading(false);
            });
    };
    return (
        <SCUIContent>
            <>
                <SCUIBreadCrumb
                    onlyTitle={t('summary.title')}
                    style={{ cursor: 'pointer' }}
                    components={[
                        {
                            title: t('summary.title'),
                            link: '/summary-list',
                            onClick: () => {
                                setSelectedSummary({});
                            },
                        },
                        ...(selectedSummary?.paymentConsolidationId
                            ? [
                                  {
                                      title: t('summary.summaryDetail'),
                                      link: '/summary-list',
                                  },
                              ]
                            : []),
                    ]}
                />
                {isLoading && (
                    <Box sx={{ margin: '24px 0 24px 0 ' }}>
                        <SCUILoadingLinear display={isLoading} />
                    </Box>
                )}
                <SummaryList
                    setIsLoading={setIsLoading}
                    summaryList={summaryList}
                    startDate={startDate}
                    endDate={endDate}
                    setStartDate={setStartDate}
                    setEndDate={setEndDate}
                    handleAxapta={handleAxapta}
                    handlePrint={handlePrint}
                    setSummaryList={setSummaryList}
                    setSelectedSummary={setSelectedSummary}
                    handleSearch={handleSearch}
                    status={status}
                    selectedSummary={selectedSummary}
                    setStatus={setStatus}
                    isSearched={isSearched}
                />
                <SummaryDetail summary={selectedSummary} setSummary={setSelectedSummary} />
            </>
        </SCUIContent>
    );
};
